import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Voy a pasar hambre?',
    a: 'No. Comerás porciones satisfactorias de alimentos que tu cuerpo sabe procesar sin esfuerzo.'
  }, {
    q: '¿Necesito suplementos caros?',
    a: 'No. Todo lo necesario se encuentra en un supermercado normal: proteínas limpias, grasas saludables y vegetales específicos.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Sí, te enseñamos cómo tomarlo estratégicamente para que no eleve tu cortisol ni te hinche.'
  }, {
    q: '¿Qué pasa si tengo una cena social?',
    a: 'El protocolo es de 72 horas para un reset total, pero incluimos una guía de emergencia para situaciones sociales.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#FDFAF5] py-20 px-4" data-id="element-29">
      <div className="max-w-[720px] mx-auto" data-id="element-30">
        <FadeIn data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-12 text-center" data-id="element-32">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-34">
              <div className="bg-white rounded-2xl border border-[#E8F5E2] overflow-hidden shadow-sm" data-id="element-35">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" aria-expanded={openIndex === index} data-id="element-36">
                  <span className="font-bold text-[#1A1A1A] text-lg" data-id="element-37">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-38">
                    <ChevronDown className="w-5 h-5 text-[#4A7C42]" data-id="element-39" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-40">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-41">
                      <div className="px-6 pb-5 text-[#5A5A5A] leading-relaxed border-t border-gray-50 pt-4" data-id="element-42">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}